import React from "react"
import { Text } from "@chakra-ui/react"

type Props = {
  value?: string | number;
}

const DefaultCell = ({ value }: Props) => (
  <Text fontSize="sm" noOfLines={1} title={value?.toString()}>
    {value?.toString() || ""}
  </Text>
)

export default DefaultCell
